import React from 'react'
import * as R from 'ramda'
import { Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const countLimitStatus = (textCount, maxLength) => {
  if (R.isNil(maxLength)) return null

  const lowerBound = Math.floor(maxLength * 0.1)
  const goodBound = Math.floor(maxLength * 0.25)
  const informativeBound = Math.floor(maxLength * 0.5)
  const middleBound = Math.floor(maxLength * 0.75)

  if (textCount <= lowerBound) return null
  if (textCount <= goodBound)
    return {
      messageId: 'notification.description.richEditor.good.label',
      emoji: '😄',
    }
  else if (textCount <= informativeBound)
    return {
      messageId: 'notification.description.richEditor.informative.label',
      emoji: '😃',
    }
  else if (textCount <= middleBound)
    return {
      messageId: 'notification.description.richEditor.meh.label',
      emoji: '😑',
    }
  else if (textCount <= maxLength)
    return {
      messageId: 'notification.description.richEditor.almostLimit.label',
      emoji: '🙁',
    }
  else
    return {
      messageId: 'notification.description.richEditor.passLimit.label',
      emoji: '😥',
    }
}

const useStyles = makeStyles((theme) => ({
  limitStatus: {
    marginRight: 8,
  },
  textCount: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
}))

const NotificationDescriptionStatus = ({ textCount, maxLength }) => {
  const classes = useStyles()
  const limitStatus = countLimitStatus(textCount, maxLength)
  return (
    limitStatus && (
      <>
        <Typography
          variant="caption"
          className={clsx(classes.textCount, 'ltr:mr-8 rtl:ml-8')}
        >
          <FormattedMessage id={R.prop('messageId', limitStatus)} />
        </Typography>
        <Typography variant="h6" className={classes.limitStatus}>
          {R.prop('emoji', limitStatus)}
        </Typography>
      </>
    )
  )
}

export default NotificationDescriptionStatus
